/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BillingPayment_billing$ref: FragmentReference;
declare export opaque type BillingPayment_billing$fragmentType: BillingPayment_billing$ref;
export type BillingPayment_billing = {|
  +stripePaymentDetail: ?any,
  +$refType: BillingPayment_billing$ref,
|};
export type BillingPayment_billing$data = BillingPayment_billing;
export type BillingPayment_billing$key = {
  +$data?: BillingPayment_billing$data,
  +$fragmentRefs: BillingPayment_billing$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BillingPayment_billing",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "stripePaymentDetail",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ce19aa22d8161a5aed456809b50c7c46';
module.exports = node;
